import { render, staticRenderFns } from "./ReleaseSettingIndex.vue?vue&type=template&id=41c08639&"
import script from "./ReleaseSettingIndex.vue?vue&type=script&lang=js&"
export * from "./ReleaseSettingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports